<template>
  <b-overlay z-index="1000" :show="isSending">
    <div class="app-container">
      <div class="center">
        <b-container fluid="md">
          <CancelAlertModal @cancel="cancel"></CancelAlertModal>
          <NotificationModal
            v-model="showNotification"
            :variant="notificationVariant"
            :message="notificationMessage"
            :additional-messages="notificationAdditionalMessages"
          ></NotificationModal>
          <form @submit.prevent="onSubmit">
            <b-card>
              <b-card-header>
                <b-row class="justify-content-md-center">
                  <b-col cols="1" class="slf-logo">
                    <img src="slflogo.svg" alt="SLF Logo" />
                  </b-col>
                  <b-col
                    cols="10"
                    style="font-size: x-large; font-weight: bold"
                  >
                    {{ $t("ui.reply") }}
                  </b-col>
                  <b-col cols="1">
                    <select v-model="$i18n.locale" class="right">
                      <option
                        v-for="(lang, i) in langs"
                        :key="`Lang${i}`"
                        :value="lang"
                      >
                        {{ lang }}
                      </option>
                    </select>
                  </b-col>
                </b-row>
              </b-card-header>
              <PersonalData />
              <router-view></router-view>
            </b-card>
          </form>
        </b-container>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import PersonalData from "./PersonalData.vue";
import store, {
  getAvalancheReport,
  getObservationReport,
} from "@/store/store.js";
import { PublicReplyService } from "@/services/PublicReplyService";
import { axiosErrorToMessageKey, logAxiosError } from "@/services/serviceUtil";
import {
  AvalancheReportStatus,
  ObservationReportStatus,
} from "@/services/rest/publicreply";
import CancelAlertModal from "@/components/modals/CancelAlertModal";
import NotificationModal, {
  Variant,
} from "@/components/modals/NotificationModal";

export default {
  name: "PublicReply",
  data() {
    return {
      showNotification: false,
      notificationVariant: Variant.success,
      notificationMessage: "",
      notificationAdditionalMessages: [],
      langs: ["de", "en", "fr", "it"],
    };
  },
  components: {
    NotificationModal,
    CancelAlertModal,
    PersonalData,
  },
  methods: {
    async onSubmit() {
      try {
        store.setSending(true);
        if (this.$route.path === "/avalanche") {
          await this.submitAvalancheReport();
        } else if (this.$route.path === "/dangerSign") {
          await this.submitObservationReport();
        }
        await this.$router.push("/");
        store.clear();
      } catch (error) {
        logAxiosError(error);
        this.notificationVariant = Variant.error;
        this.notificationMessage = this.$t(axiosErrorToMessageKey(error));
        this.notificationAdditionalMessages = [];
      } finally {
        store.setSending(false);
      }
      this.showNotification = true;
    },
    async submitAvalancheReport() {
      const avalancheReport = getAvalancheReport(store);
      const result = await PublicReplyService.submitAvalancheReport(
        avalancheReport
      );
      const { reportStatus, failedDocumentNames } = result.data;
      if (reportStatus === AvalancheReportStatus.PartialSuccessDocumentFail) {
        this.notificationVariant = Variant.warning;
        this.notificationMessage = this.$t("ui.modalPartialSuccess");
        this.notificationAdditionalMessages = failedDocumentNames || [];
      } else {
        this.notificationVariant = Variant.success;
        this.notificationMessage = this.$t("ui.modalSuccess");
        this.notificationAdditionalMessages = [];
      }
    },
    async submitObservationReport() {
      const observationReport = getObservationReport(store);
      const result = await PublicReplyService.submitObservationReport(
        observationReport
      );
      const { reportStatus, failedDocumentNames } = result.data;
      if (
        reportStatus === ObservationReportStatus.PartialSuccessSomeDocumentsFail
      ) {
        this.notificationVariant = Variant.warning;
        this.notificationMessage = this.$t("ui.modalPartialSuccess");
        this.notificationAdditionalMessages = failedDocumentNames || [];
      } else {
        this.notificationVariant = Variant.success;
        this.notificationMessage = this.$t("ui.modalSuccess");
        this.notificationAdditionalMessages = [];
      }
    },
    cancel() {
      this.$router.push("/");
      store.setCancelAlert(false);
    },
  },
  computed: {
    isSending() {
      return store.isSending();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
div.slf-logo > img {
  width: 36px;
  height: 36px;
}
div.slf-logo {
  text-align: left;
}
.cardHeader {
  font-size: large;
  font-weight: bold;
}
.right {
  float: right;
}
.inputFormRow {
  padding-top: 40px;
  text-align: left;
}
.divider {
  width: 5px;
  height: auto;
  display: inline-block;
}
.mapButton {
  margin-top: 15px;
}
.componentButton {
  height: 300px;
  width: 90%;
  font-size: xx-large;
  font-weight: bold;
}
.modal-header .close {
  display: none;
}
.app-container {
  height: 100vh;
  overflow: auto;
}
</style>
